import React from 'react';
import BannerComponent from './banner.component';

const Banner = (props) => {
    return <BannerComponent {...props} />;
};

export default Banner;
